import { atom } from "jotai";
import ReferencePanelContextRecord from "models/view-models/reference-panel-context-record";

const ReferencePanelContextAtom = atom<ReferencePanelContextRecord>(
    new ReferencePanelContextRecord()
);

export default ReferencePanelContextAtom;
